module.exports = __webpack_public_path__ + "img/img_kiwoom_account.d8e2f1fc.jpg";